import { render } from "./AnimatedComponent.vue?vue&type=template&id=547affaa&scoped=true"
import script from "./AnimatedComponent.vue?vue&type=script&lang=js"
export * from "./AnimatedComponent.vue?vue&type=script&lang=js"

import "./AnimatedComponent.vue?vue&type=style&index=0&id=547affaa&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-547affaa"]])

export default __exports__